<template>
  <div class="home-container">
    <van-tabs
      type="line"
      line-height="0px"
      v-model="activeName"
      title-active-color="#3994E7"
      title-inactive-color="#333333"
    >
      <van-tab v-for="item in tabs" :name="item.name" :key="item.name">
        <template #title>
          <div>{{ item.name }}</div>
        </template>
        <recommend-list v-if="item.categoryId == 1"></recommend-list>
        <exam-category-list
          v-else-if="item.categoryId == 2"
        ></exam-category-list>
        <article-list :extensionType="item.extensionType" v-else></article-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import RecommendList from "./RecommendList";
import ExamCategoryList from "./ExamCategoryList";
import ArticleList from "./ArticleList";
import * as ActionTypes from "../../../store/action-types";
import { reportHomeEntry } from "@/api/report";

export default {
  components: {
    RecommendList,
    ExamCategoryList,
    ArticleList,
  },
  data() {
    return {
      tabs: [
        { name: "精选文章", categoryId: 1 },
        { name: "考试", categoryId: 2 },
        { name: "科学", categoryId: 3, extensionType: 1 },
        { name: "艺术", categoryId: 3, extensionType: 2 },
        { name: "人文", categoryId: 3, extensionType: 3 },
      ],
      activeName: 2,
    };
  },
  activated() {
    window.addEventListener("popstate", this.onBack, false);
    this.$store.dispatch(ActionTypes.GET_USER_INFO);
    if (this.$router.currentRoute.query.entry) {
      reportHomeEntry({ entry: this.$router.currentRoute.query.entry }).then(()=>{}).catch(()=>{});
    }
    const tabIndex = this.$router.currentRoute.query.tabIndex
    if (tabIndex && tabIndex < this.tabs.length) {
      this.activeName = this.tabs[tabIndex].name
    }
  },

  destroyed() {
    window.removeEventListener("popstate", this.onBack, false);
  },
  methods: {
    onBack() {
      // this.$router.replace({ path: "/home" });
      // window.location.href = "/home"
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../common/stylus/index.styl';

.home-container {
  background-color: $home-bg;
  margin-bottom: 80px;
  width: 100vw;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.tab-item-text {
  color: $main-blue;
}
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Home/index.vue